@if (totalRows !== 0) {
  <div class="table-container">
    <div class="title-row">
      <div class="first-data-col data-col"></div>
      <div class="data-col">
        {{ 'ANALYTICS.VITAL_METRICS_MODAL.COLUMNS.DESKTOP' | translate }}
      </div>
      <div class="data-col">
        {{ 'ANALYTICS.VITAL_METRICS_MODAL.COLUMNS.MOBILE' | translate }}
      </div>
    </div>
    <div class="data-container">
      @for (cardRow of records; track cardRow) {
        <div class="data-row">
          <div class="first-data-col data-col">
            <span class="value">
              <a [href]="cardRow.link" target="_blank">
                {{ cardRow.metricTitle }}
              </a>
            </span>
          </div>
          <div class="data-col">
            <span class="value">
              {{ cardRow.desktopDisplayValue }}
            </span>
          </div>
          <div class="data-col">
            <span class="value">
              {{ cardRow.mobileDisplayValue }}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="no-data-container">
    <div class="no-data">
      <mat-icon>bar_chart</mat-icon>
      <h3>No data yet</h3>
    </div>
  </div>
}

